import React from 'react';

class SectionFive extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    let page_id = this.props.page_id;
    let sectionData = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.logos : [];
    let options = this.props.options;
    options = options.options ? options.options : {};

    if(!Object.keys(sectionData).length || !Object.keys(options).length) return [];

    let logos_html = sectionData.map((item, key) => {
        return (<span key={key}><img src={item.logo.url} alt={item.logo.alt} title={item.logo.title} /></span>);
    })

    return (
        <section className="section section-layout-3">
            <div className="main-container">
                <div className="layout layout-3 fullH">
                    <div className="grid">
                        <article className="title-md">
                            <p>{options.office_details}</p>
                            <a target="_blank" href="https://www.google.com/maps/place/++Le+Lay+Architects/@51.4843936,-0.1723475,15z">
                                <div dangerouslySetInnerHTML={{__html:options.office_address}} />
                            </a>
                            <p><a href={`mailto:${options.contact_email}`}>{options.contact_email}</a></p>
                            <p><a href={`tel:+${options.contact_number}`}>{options.contact_number}</a></p>
                        </article>
                        <figure>
                            <p><img className="w-100" src={options.studio_image} /></p>
                            <figcaption className="mt-20 d-inline-block">{options.image_caption}</figcaption>
                        </figure>
                    </div>
                    <div className="grid">
                        <figure className="logos">
                            {logos_html}
                        </figure>
                    </div>
                </div>
            </div>
        </section>
    );
  }
}

export default SectionFive;



// WEBPACK FOOTER //
// ./src/components/Practice/SectionFive.js